"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useApprovalWaveStatus } from "@/hooks/waves/useApprovalWaveStatus";
import { SingleWaveDropWrapper } from "./SingleWaveDropWrapper";
import { SingleWaveDropInfoPanel } from "./SingleWaveDropInfoPanel";
import { useSingleWaveDropData } from "./useSingleWaveDropData";
interface DefaultSingleWaveDropProps {
  readonly drop: ExtendedDrop;
  readonly onClose: () => void;
}
export const DefaultSingleWaveDrop: React.FC<DefaultSingleWaveDropProps> = t0 => {
  const $ = _c(16);
  const {
    drop: initialDrop,
    onClose
  } = t0;
  const {
    drop,
    wave,
    extendedDrop
  } = useSingleWaveDropData(initialDrop, onClose);
  let t1;
  if ($[0] !== wave) {
    t1 = {
      wave
    };
    $[0] = wave;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    winningThreshold,
    winningThresholdMinDurationMs,
    isVotingClosed,
    isVotingControlsLocked
  } = useApprovalWaveStatus(t1);
  if (!extendedDrop || !wave || !drop) {
    return null;
  }
  let t2;
  if ($[2] !== extendedDrop || $[3] !== isVotingClosed || $[4] !== isVotingControlsLocked || $[5] !== winningThreshold) {
    t2 = <SingleWaveDropInfoPanel drop={extendedDrop} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} winningThreshold={winningThreshold} />;
    $[2] = extendedDrop;
    $[3] = isVotingClosed;
    $[4] = isVotingControlsLocked;
    $[5] = winningThreshold;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== drop || $[8] !== isVotingClosed || $[9] !== isVotingControlsLocked || $[10] !== onClose || $[11] !== t2 || $[12] !== wave || $[13] !== winningThreshold || $[14] !== winningThresholdMinDurationMs) {
    t3 = <SingleWaveDropWrapper drop={drop} wave={wave} onClose={onClose} winningThreshold={winningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked}>{t2}</SingleWaveDropWrapper>;
    $[7] = drop;
    $[8] = isVotingClosed;
    $[9] = isVotingControlsLocked;
    $[10] = onClose;
    $[11] = t2;
    $[12] = wave;
    $[13] = winningThreshold;
    $[14] = winningThresholdMinDurationMs;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};